import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
var DEFAULT_SWIPER_CONFIG = {
    observer: true,
    direction: 'horizontal',
    spaceBetween: 5,
    centeredSlides: false,
    scrollbar: false
};
var ɵ0 = DEFAULT_SWIPER_CONFIG;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
